<template>
  <form @submit.prevent="handleSubmit">
    <v-container class="main-container responsive-height">
      <v-row dense>
        <v-col xl="6" lg="6" md="7" sm="7" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-card-title class="otp-title ps-0 pb-0"
                  >OTP has been sent to your <span v-if="otp_via == 2">phone number.</span> <span v-if="otp_via == 1">email address.</span> <span v-if="otp_via == 3">phone no and email address both.</span></v-card-title
                >
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Enter OTP</legend>
                  <v-text-field v-model="otp" label="Enter OTP" single-line solo hide-details class="custom-select"
                    :rules="[v => !!v || 'OTP is required']" :error="!!error" :error-messages="error"
                    @input="error = ''"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-btn tile elevation="0" class="ma-0 text-capitalize btn-account d-block" color="greenMain"
                  :loading="loading" type="submit">
                  Confirm
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { WITHDRAWMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  name: 'CryptoWithdrawFormOtp',

  data() {
    return {
      otp: '',
      loading: false,
      error: '',
      showSuccessDialog: false,
      formData: {
        trading_account_no: '',
        amount: '',
        payment_id: '',
        wallet_address: '',
        network: ''
      }
    };
  },

  computed: {
    ...mapState("withdraw", ["otp_via"]),
  },

  methods: {
    ...mapActions("withdraw", [
      WITHDRAWMETHODS__ACTIONS.CREATECRYPTOWITHDRAW,
      WITHDRAWMETHODS__ACTIONS.OTPVIA,
    ]),

    async handleSubmit() {
      if (!this.otp) {
        this.error = 'Please enter OTP';
        return;
      }

      this.loading = true;
      try {
        const withdrawalData = {
          trading_account_no: this.formData.trading_account_no,
          amount: this.formData.amount,
          wallet_address: this.formData.wallet_address,
          network: this.formData.network,
          payment_id: this.formData.payment_id,
          otp: this.otp
        };

        await this[WITHDRAWMETHODS__ACTIONS.CREATECRYPTOWITHDRAW](withdrawalData);
        this.showSuccessDialog = true;
      } catch (error) {
        this.error = error.message || 'Invalid OTP. Please try again.';
        toast.error(this.error);
      } finally {
        this.loading = false;
      }
    },

    getQueryParams() {
      const { payment_id, trading_account_no, amount, wallet_address, network } = this.$route.query;

      if (!payment_id || !trading_account_no || !amount) {
        toast.error('Invalid request parameters');
        return;
      }

      this.formData = {
        trading_account_no,
        amount,
        payment_id,
        wallet_address,
        network
      };
    }
  },

  async created() {
    this.getQueryParams();
    await this[WITHDRAWMETHODS__ACTIONS.OTPVIA]();
  }
};
</script>